import { AfterViewInit, Directive, Input, OnDestroy } from "@angular/core";
import { uniqueId } from "lodash-es";
import { NgScrollbar } from "ngx-scrollbar";

import { ScrollToTopOptions } from "./scroll-to-top.model";
import { ScrollToTopService } from "./scroll-to-top.service";

@Directive({
	selector: "ng-scrollbar[obgScrollToTop]",
})
export class ScrollToTopDirective implements OnDestroy, AfterViewInit {
	@Input("obgScrollToTop") options: ScrollToTopOptions | undefined;

	private id = uniqueId();

	constructor(
		private scrollToTopService: ScrollToTopService,
		private scrollbarComponent: NgScrollbar
	) {}

	ngAfterViewInit() {
		if (!this.options || !this.scrollbarComponent) {
			return;
		}

		this.scrollToTopService.register({
			...this.options,
			id: this.id,
			element: this.scrollbarComponent,
		});
	}

	ngOnDestroy() {
		this.scrollToTopService.unregister(this.id);
	}
}
